(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cronduit-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-cronduit-sticky-cta]');
    if (!el) return;
    var threshold = 0.6;
    function check() {
      var scrolled = window.scrollY;
      var trigger = window.innerHeight * threshold;
      if (scrolled > trigger) {
        el.classList.add('cronduit-sticky-cta--visible');
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.classList.remove('cronduit-sticky-cta--visible');
        el.setAttribute('aria-hidden', 'true');
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-cronduit-toggle]');
    var header = document.querySelector('[data-cronduit-header]');
    if (!toggle || !header) return;
    toggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    header.querySelectorAll('.cronduit-header__link').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
